import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getData = async () => {
  const response = await axios.get(`/camouflages`)
  return response.data
};

export default function useDefaultCamouflages() {
    const { data, isLoading, error } = useQuery({
    queryKey: ["camouflages"],
    queryFn: () => getData(),
  });

  return { data, isLoading, error }
}